import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";

// redux
import { useSelector } from "react-redux";

// Import Images
import logodark from "../../assets/images/logo-dark.png";
import logolight from "../../assets/images/logo-light.png";
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';

import AuthSlider from './authCarousel';

const Register = () => {
    const { layoutMode } = useSelector((state) => ({
        layoutMode: state.Layout.layoutMode,
    }));

    useEffect(() => {
        if (layoutMode === "dark") {
            document.body.classList.remove("bg-transparent");
        } else {

            document.body.className = "bg-transparent";
        }
        // remove classname when component will unmount
        return function cleanup() {
            document.body.className = "";
        };
    });
    return (
        <React.Fragment>
            <Helmet>
                <title>Register | Borex - React Admin & Dashboard Template</title>
            </Helmet>
            <div className="auth-page">
                <Container fluid className="p-0">
                    <Row className="g-0 align-items-center">
                        <Col className="col-xxl-4 col-lg-4 col-md-6">
                            <Row className="justify-content-center g-0">
                                <Col xl={9}>
                                    <div className="p-4">
                                        <Card className="mb-0">
                                            <CardBody>
                                                <div className="auth-full-page-content rounded d-flex p-3 my-2">
                                                    <div className="w-100">
                                                        <div className="d-flex flex-column h-100">
                                                            <div className="mb-4 mb-md-5">
                                                                <Link to="/index" className="d-block auth-logo">
                                                                    <img src={logodark} alt="" height="22" className="auth-logo-dark me-start" />
                                                                    <img src={logolight} alt="" height="22" className="auth-logo-light me-start" />
                                                                </Link>
                                                            </div>

                                                            <div className="auth-content my-auto">
                                                                <div className="text-center">
                                                                    <h5 className="mb-0">Register Account</h5>
                                                                    <p className="text-muted mt-2">Get your free Borex account now.</p>
                                                                </div>
                                                                <form className="mt-4 pt-2" action="/">
                                                                    <div className="form-floating form-floating-custom mb-4">
                                                                        <input type="email" className="form-control" id="input-email" placeholder="Enter Email" required />
                                                                        <div className="invalid-feedback">
                                                                            Please Enter Email
                                                                        </div>
                                                                        <label htmlFor="input-email">Email</label>
                                                                        <div className="form-floating-icon">
                                                                        <i className='bx bx-mail-send' />
                                                                        </div>
                                                                    </div>

                                                                    <div className="form-floating form-floating-custom mb-4">
                                                                        <input type="text" className="form-control" id="input-username" placeholder="Enter User Name" required />
                                                                        <div className="invalid-feedback">
                                                                            Please Enter Username
                                                                        </div>
                                                                        <label htmlFor="input-username">Username</label>
                                                                        <div className="form-floating-icon">
                                                                        <i className='bx bx-user' />

                                                                        </div>
                                                                    </div>

                                                                    <div className="form-floating form-floating-custom mb-4">
                                                                        <input type="password" className="form-control" id="input-password" placeholder="Enter Password" required />
                                                                        <div className="invalid-feedback">
                                                                            Please Enter Password
                                                                        </div>
                                                                        <label htmlFor="input-password">Password</label>
                                                                        <div className="form-floating-icon">
                                                                        <i className='bx bx-lock' />
                                                                        </div>
                                                                    </div>

                                                                    <div className="mb-4">
                                                                        <p className="mb-0">By registering you agree to the Borex <Link to="#" className="text-primary">Terms of Use</Link></p>
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <button className="btn btn-primary w-100 waves-effect waves-light" type="submit">Register</button>
                                                                    </div>
                                                                </form>

                                                                <div className="mt-4 pt-3 text-center">
                                                                    <div className="signin-other-title">
                                                                        <h5 className="font-size-14 mb-4 text-muted fw-medium">- Or you can join with -</h5>
                                                                    </div>

                                                                    <div className="d-flex gap-2">
                                                                        <button type="button" className="btn btn-soft-primary waves-effect waves-light w-100">
                                                                            <i className="bx bxl-facebook font-size-16 align-middle"></i>
                                                                        </button>
                                                                        <button type="button" className="btn btn-soft-info waves-effect waves-light w-100">
                                                                            <i className="bx bxl-linkedin font-size-16 align-middle"></i>
                                                                        </button>
                                                                        <button type="button" className="btn btn-soft-danger waves-effect waves-light w-100">
                                                                            <i className="bx bxl-google font-size-16 align-middle"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                <div className="mt-4 pt-3 text-center">
                                                                    <p className="text-muted mb-0">Already have an account ? <Link to="/auth-login" className="text-primary fw-semibold"> Login </Link> </p>
                                                                </div>
                                                            </div>


                                                            <div className="mt-4 text-center">
                                                                <p className="mb-0">© {new Date().getFullYear()} Borex   . Crafted with <i className="mdi mdi-heart text-danger"></i> by Themesbrand</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <AuthSlider />
                    </Row>
                </Container>
            </div>
        </React.Fragment >
    );
};

export default Register;